/* 


@PRAKT


   _____________________________________________________________

   |
   | CONTACT FORM
   |
   _____________________________________________________________
*/

/* ______________________________________________________________

   |
   | CLASS
   |
   ______________________________________________________________
*/

export default class ContactFrom {
    constructor() {
        this.init();
    }

    init() {
        this.file = document.querySelector( '#ContactForm-file');
        if( !this.file ) return;
        this.form = document.querySelector( '#ContactForm' );
        this.server_url = 'https://hcc.prakt.dev';
        this.server_upload_folder = 'uploads';
        this.hidden_file = document.querySelector( '#ContactFormFile' );
        this.submit_button = document.querySelector( '.submit_button' );
        this.form_has_file = false;
        this.lockFormSubmit();
        this.fileInput();
        this.formSubmit();
    }

    lockFormSubmit() {
        this.form.addEventListener( 'submit', ( event ) => {
            event.preventDefault();
        } );
    }

    formSubmit() {
        this.submit_button.addEventListener( 'click', () => {
            this.controlRequiredFields();
        } );
    }

    controlRequiredFields() {
        const fields = this.form.querySelectorAll( 'input' );
        let can_send = true;
        fields.forEach( f => {
            if( f.hasAttribute( 'required' ) && !f.value ) {
                can_send = false;
            }
        });
        if( can_send ) {
            // console.log('submit');
            this.getData();
            this.form.submit();
        } else {
            console.log('ERROR: Required fields');
        }
        if( can_send && this.form_has_file ) {
            this.sendFile();
        }
    }

    fileInput() {
        this.file.addEventListener( 'change', () => {
            const files = this.file.files;
            this.file_file = files[ 0 ];
            this.file_name = files[ 0 ].name;
            this.file_type = files[ 0 ].type;
            this.form_data = new FormData();
            this.form_data.append( 'files[]', this.file_file );
            this.form_has_file = true;
            this.file_url = this.server_url + '/' + this.server_upload_folder +  '/' + this.file_name;
            this.hidden_file.value = this.file_url;
        } );
    }

    sendFile() {
        let params = {
            "method": "POST",
            "body": this.form_data
         }
         fetch( this.server_url+'/hcc-file-upload.php', params )
         .then( ( response ) => {
            // console.log( response );
            response.json().then((data) => {
                // info
                // data[ 0 ] = message
                // data[ 1 ] = filename
            });
         } );
    }

    getData() {
        let results;
        let time_stamp = this.setTimeStamp();
        time_stamp = time_stamp.split( '-' );
        let stat_line = time_stamp[0] + `,`;
        stat_line += time_stamp[1] + `,`;
        // const submitter = this.submit_button;
        // const formData = new FormData(this.form, submitter);
        const form_data = new FormData( this.form );
        for ( const [ key, value ] of form_data) {
            results += `${ key }: ${ value }\n`;
            if( key == 'contact[Gender]' ) stat_line += `${ value },`;
            if( key == 'contact[Firstname]' ) stat_line += `${ value },`;
            if( key == 'contact[Name]' ) stat_line += `${ value },`;
            if( key == 'contact[Birthdate]' ) stat_line += `${ value },`;
            if( key == 'contact[Email]' ) stat_line += `${ value },`;
            if( key == 'contact[Phone]' ) stat_line += `${ value },`;
            if( key == 'contact[Location]' ) stat_line += `${ value },`;
            if( key == 'contact[File]' ) stat_line += `${ value },`;
            if( key == 'contact[Comment]' ) stat_line += `${ value }`;
        }
        // console.log(results);
        // console.log(stat_line);
        this.stat_line = stat_line;
        this.sendData( 'hcc-contact-data' );
    }

    sendData( php_data_ ) {
        const php_data = php_data_;
        const form_data = new FormData();
        form_data.append( 'stat_line', this.stat_line );
        let params = {
            "method": "POST",
            "body": form_data
         }
         fetch( this.server_url+'/'+php_data+'.php', params )
        //  .then( ( response ) => {
        //     // console.log( response );
        //     response.json().then((data) => {
        //         console.log(data);
        //     });
        //  } );
    }

    setTimeStamp() {
        const date = new Date();
        const y = date.getFullYear();
        const m = date.getMonth();
        const d = date.getDate();
        const h = date.getHours();
        const min = date.getMinutes();
        const s = date.getSeconds();
        const m_clean = ( Number( m ) + 1 );
        const time_stamp = `${ y }/${ m_clean }/${ d }-${ h }:${ min }:${ s }`;
        return time_stamp;
    }
}